export default __webpack_public_path__ + "static/media/0718_DSC7951.2467e4d1.jpg";